<div *ngIf="!PageView;else other_content">

    <!-- New Design -->
    <div class="InCred_Outer">
        <section *ngIf="!IsMobile" class="left">
            <div class="deco-anim"></div>
            <div class="illustration">
            </div>
            <div class="BG_Img">
                <div>
                    <img src="../../../assets/images/INC_Illustration.svg" class="img-fluid" alt="">
                </div>
                <p class="tagline">
                  Seamless <span class="highlight-yellow">Wealth <span class="Flow_1">fl</span><img src="../../../assets/images/Money_gif.gif" width="44px" class="Flow_Gif" alt=""><span class="Flow_2">w</span></span> &amp;
                  <span class="highlight-orange">Investing<br>Experience</span> for Financial Professionals
                </p>
            </div>
          </section>
        <section class="right">
            <div class="logo">
                <img src="../../../assets/images/Login_Logo.svg" alt="">
            </div>
            <div class="UnderLineTabs">
                <ul class="nav nav-tabs" id="myTab" role="tablist" [ngClass]="!IsMobile ? 'w-100':''">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="one-tab" data-toggle="tab" data-target="#one" type="button"
                            role="tab" aria-controls="one" aria-selected="true">Login</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="two-tab" data-toggle="tab" data-target="#two" type="button" role="tab"
                            aria-controls="two" aria-selected="false" disabled>
                        <span class="LinkandIcon">
                            <img src="../../../assets/images/Mpin_icn.svg" class="svg Tab_Img" alt="">
                            MPIN
                        </span>
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="three-tab" data-toggle="tab" data-target="#three" type="button" role="tab"
                            aria-controls="three" aria-selected="false" disabled> <span class="LinkandIcon">
                                <img src="../../../assets/images/Qr_icn.svg" class="svg Tab_Img" alt="">
                                QR Code
                                <span class="badgeCS">Coming soon</span>
                            </span>
                        </button>
                    </li>
                </ul>
            </div>
            <div class="tab-content mt-4" id="myTabContent">
                <div class="tab-pane fade show active" id="one" role="tabpanel" aria-labelledby="one-tab">
                    <div class="row">
                        <div class="col-md-12 mx-auto">
                            <div class="step-opne">
                                <form appNoAutofill autocomplete="off" [formGroup]="LoginForm" (ngSubmit)="onSubmit()" class="LoginForm">

                                    <div class="LoginFormDefultBox UserInputContainer ">
                                        <div class="UserInputContainer">
                                            <label for="Username" class="lable">
                                                Pan number
                                            </label>
                                            <input id="Username" type="text" formControlName="Username"
                                                oninput="this.value = this.value.toUpperCase()" autofocus
                                                class="form-control LoginFormInputTextBox"
                                                [ngClass]="{ 'is-invalid': LoginSubmitted && r.Username.errors }"
                                                placeholder="Enter Pan number" maxlength="25" />

                                            <div *ngIf="LoginSubmitted && r.Username.errors" class="invalid-feedback">
                                                <div *ngIf="r.Username.errors.required">Please enter your Pan number.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col InputBoxOuter mb-2">
                                                <div class="UserInputContainer">
                                                    <label for="Password" class="lable">
                                                        Password
                                                    </label>
                                                    <show-hide-password btnStyle="" id="PasswordField" [btnOutline]="false"
                                                        class="Pass">
                                                        <input id="Password" type="password" formControlName="Password"
                                                            class="form-control LoginFormInputTextBox"
                                                            [ngClass]="{ 'is-invalid': LoginSubmitted && r.Password.errors }"
                                                            placeholder="Enter Password" maxlength="20" />
                                                        <div *ngIf="LoginSubmitted && r.Password.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="r.Password.errors.required">Please enter
                                                                your
                                                                password.
                                                            </div>
                                                            <div *ngIf="r.Password.errors.pattern">Password contains
                                                                atleast 1
                                                                numeric , 1 uppercase, 1 lowercase and 1 special
                                                                character
                                                            </div>
                                                            <!--Password contains atleast 1 number, 1 uppercase, 1 lowercase and 1 special charactor (@$!%*?&#)-->
                                                        </div>
                                                    </show-hide-password>
                                                </div>
                                                <!-- <span routerLink="/forgot-password-incred" routerLinkActive="active"
                                                    class="ForgetPassLink" (click)="SendUserType()">
                                                    Forgot Password?
                                                </span> -->
                                            </div>
                                        </div>
                                        <div class="destination-row">
                                        <span>Take me to</span>
                                        <select class="form-control CommonSelectBox TbxMarginBtm TakeMeTo_DDl">
                                            <!-- <option value="" disabled>Select</option> -->
                                            <option value="/client-dashboard" selected>Dashboard</option>
                                            <option value="/transaction-new-latest/lumpsum">Transact</option>
                                            <option value="/reports-new/dashboard">Reports</option>
                                            <option value="/explore-funds-new-latest">Explore Schemes</option>
                                        </select>
                                            <!-- <button class="dest-select">
                                                Equity Dashboard
                                                <div class="dest-arrow">▾</div>
                                            </button> -->
                                        </div>
                                        <button class="CommonSubmitButton mt-0 mb-1">Sign in &nbsp;→</button>
                                    </div>

                                    <div class="OtpVerificationBox d-none">
                                        <div class=" ">
                                            <div class="OtpVerificationTopGrid">
                                                <div class="TopLeftArrowImg">
                                                    <img src="../../assets/images/IIFL_New_Icons/TopLeftArrow.svg" alt="">
                                                </div>
                                                <div class="OtpVerificationTitle">
                                                    OTP Verification
                                                </div>
                                            </div>
                                            <p class="OtpVerificationParagraph">Please enter the OTP sent to your
                                                registered <br> Mobile Number <span>*****3098</span> </p>
                                        </div>
                                        <div class="row ">
                                            <div class="col InputBoxOuter">
                                                <div class=" UserInputContainer">
                                                    <div class="">
                                                        <label for="Otp" class="lable OtpText">
                                                            Enter 6 digit OTP
                                                        </label>
                                                        <ng-otp-input id="OTPBox" #ngOtpInput [config]="{
                                                                                length: 6,
                                                                                inputClass: 'OTPBox',
                                                                                allowNumbersOnly: true,
                                                                                disableAutoFocus: false,
                                                                                inputStyles: {
                                                                                'text-security': 'disc',
                                                                                '-webkit-text-security': 'disc',
                                                                                '-moz-text-security': 'disc'
                                                                                },
                                                                                isNumberInput: true
                                                                            }" inputmode="numeric" pattern="[0-9]*">
                                                        </ng-otp-input>
                                                        <div class="ResendText">
                                                            <span class="ResendLink"> Resent OTP in
                                                                <span id="timer">15 sec</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <button class="CommonSubmitButton  d-none">Generate OTP</button>
                                        <button class="CommonSubmitButton">Verify</button>
                                    </div>

                                    <div class="SetNewPasswordBox d-none">
                                        <div class="">
                                            <div class="OtpVerificationTopGrid">
                                                <div class="TopLeftArrowImg">
                                                    <img src="../../assets/images/IIFL_New_Icons/TopLeftArrow.svg" alt="">
                                                </div>
                                                <div class="OtpVerificationTitle SetNewPasswordtitle">
                                                    Set New Password
                                                </div>
                                            </div>
                                            <p class="OtpVerificationParagraph SetNewPasswordParagraph">Please enter
                                                a new password </p>
                                        </div>
                                        <!-- SetNewPasswordtitle end -->
                                        <div class="row ">
                                            <div class="col InputBoxOuter">
                                                <div class=" UserInputContainer">
                                                    <!-- NewPassword input box start -->
                                                    <div class="">
                                                        <div class="NewPasswordBox">
                                                            <label for="NewPassword" class="lable">
                                                                New Password
                                                            </label>
                                                            <show-hide-password btnStyle="" [btnOutline]="false" class="">
                                                                <input id="NewPassword" type="text"
                                                                    formControlName="NewPassword" autofocus
                                                                    class="form-control LoginFormInputTextBox"
                                                                    placeholder="&nbsp;" maxlength="20" />
                                                            </show-hide-password>

                                                            <div class="PasswordValidationsBox">
                                                                <div class="FirstValidation PasswordValidation">
                                                                    <div class="FirstValidationImg">
                                                                        <img src="../../assets/images/IIFL_New_Icons/PasswordValidationIcon1.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="FirstValidationText">8 - 12
                                                                        Characters</div>
                                                                </div>
                                                                <div class="SecondValidation PasswordValidation ">
                                                                    <div class="FirstValidationImg">
                                                                        <img src="../../assets/images/IIFL_New_Icons/PasswordValidationIcon1.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="FirstValidationText">Atleast 1
                                                                        Number</div>
                                                                </div>
                                                                <div class="ThirdValidation PasswordValidation ">
                                                                    <div class="FirstValidationImg">
                                                                        <img src="../../assets/images/IIFL_New_Icons/PasswordValidationIcon1.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="FirstValidationText">Do not have
                                                                        space & dots</div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div class="ConfirmPasswordBox ">
                                                            <label for="ConfirmPassword" class="lable">
                                                                Confirm Password
                                                            </label>
                                                            <show-hide-password btnStyle="" [btnOutline]="false" class="">
                                                                <input id="NewPassword" type="text"
                                                                    formControlName="NewPassword" autofocus
                                                                    class="form-control LoginFormInputTextBox"
                                                                    placeholder="&nbsp;" maxlength="25" />
                                                            </show-hide-password>

                                                            <div class="UnMatch_Validation">Password does not match
                                                            </div>
                                                            <div class="Match_Validation">
                                                                <img src="../../assets/images/IIFL_New_Icons/GreenValidationIcon.svg"
                                                                    alt="">Password match
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- NewPassword input box end -->
                                                </div>
                                            </div>
                                        </div>

                                        <!-- New Password button start-->
                                        <div class="text-center">
                                            <button class="CommonSubmitButton ">New Password</button>
                                        </div>
                                        <!-- New Password button end-->

                                    </div>

                                    <div class="ResetPasswordBox d-none">
                                        <!-- ResetPasswordtitle start -->
                                        <div class="">
                                            <div class="OtpVerificationTopGrid">
                                                <div class="TopLeftArrowImg">
                                                    <img src="../../assets/images/IIFL_New_Icons/TopLeftArrow.svg" alt="">
                                                </div>
                                                <div class="OtpVerificationTitle SetNewPasswordtitle">
                                                    Reset Password
                                                </div>
                                            </div>
                                            <p class="OtpVerificationParagraph SetNewPasswordParagraph">Please enter
                                                a new password </p>
                                        </div>
                                        <!-- ResetPasswordtitle end -->
                                        <div class="row ">
                                            <div class="col InputBoxOuter">
                                                <div class=" UserInputContainer">
                                                    <!-- ResetPassword input box start -->
                                                    <div class="">
                                                        <div class="NewPasswordBox">
                                                            <label for="NewPassword" class="lable">
                                                                Reset Password
                                                            </label>
                                                            <show-hide-password btnStyle="" [btnOutline]="false" class="">
                                                                <input id="NewPassword" type="text"
                                                                    formControlName="NewPassword" autofocus
                                                                    class="form-control LoginFormInputTextBox"
                                                                    placeholder="&nbsp;" maxlength="25" />
                                                            </show-hide-password>

                                                            <div class="PasswordValidationsBox">
                                                                <div class="FirstValidation PasswordValidation">
                                                                    <div class="FirstValidationImg">
                                                                        <img src="../../assets/images/IIFL_New_Icons/PasswordValidationIcon1.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="FirstValidationText">8 - 12
                                                                        Characters</div>
                                                                </div>
                                                                <div class="SecondValidation PasswordValidation ">
                                                                    <div class="FirstValidationImg">
                                                                        <img src="../../assets/images/IIFL_New_Icons/PasswordValidationIcon1.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="FirstValidationText">Atleast 1
                                                                        Number</div>
                                                                </div>
                                                                <div class="ThirdValidation PasswordValidation ">
                                                                    <div class="FirstValidationImg">
                                                                        <img src="../../assets/images/IIFL_New_Icons/PasswordValidationIcon1.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="FirstValidationText">Do not have
                                                                        space & dots</div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div class="ConfirmPasswordBox ">
                                                            <label for="ConfirmPassword" class="lable">
                                                                Confirm Password
                                                            </label>
                                                            <show-hide-password btnStyle="" [btnOutline]="false" class="">
                                                                <input id="NewPassword" type="text"
                                                                    formControlName="NewPassword" autofocus
                                                                    class="form-control LoginFormInputTextBox"
                                                                    placeholder="&nbsp;" maxlength="25" />
                                                            </show-hide-password>

                                                            <div class="UnMatch_Validation">Password does not match
                                                            </div>
                                                            <div class="Match_Validation">
                                                                <img src="../../assets/images/IIFL_New_Icons/GreenValidationIcon.svg"
                                                                    alt="">Password match
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- ResetPassword input box end -->
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Reset Password button start-->
                                        <div class="text-center w-100">
                                            <button class="CommonSubmitButton ">Reset Password</button>
                                        </div>
                                        <!-- Reset Password button end-->
                                    </div>

                                    <div class="PasswordSetSuccessfullyGreetingBox d-none">
                                        <div class="row ">
                                            <div class="col InputBoxOuter">

                                                <div class=" UserInputContainer">
                                                    <!-- PasswordSetSuccessfully Greeting box start -->
                                                    <div class="">
                                                        <div class="GreetingBox">

                                                            <div class="GreetingImg">
                                                                <img src="../../assets/images/IIFL_New_Icons/PasswordSetSuccessIcon.svg"
                                                                    alt="">
                                                            </div>

                                                            <div class="GreetingText">
                                                                Your password <br> has been set successfully!
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- PasswordSetSuccessfully Greeting box end -->
                                                </div>
                                            </div>
                                        </div>

                                        <!-- PasswordSetSuccessfully Greeting Login button start-->
                                        <div class="text-center w-100 mb-5">
                                            <button class="CommonSubmitButton PasswordSetSuccessGreetingBtn ">Login</button>
                                        </div>
                                        <!-- PasswordSetSuccessfully Greeting Login button end-->
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade " id="two" role="tabpanel" aria-labelledby="two-tab">
                    <div class="row">
                        <div class="col-md-12 mx-auto">
                            <div class="step-opne">
                                <form appNoAutofill autocomplete="off" [formGroup]="EmailLoginForm">
                                    <div class="row">
                                        <div class="col InputBoxOuter">
                                            <div class="has-float-label">
                                                <input type="text" id="Email" formControlName="Email" autofocus
                                                    class="form-control LoginFormInputTextBox "
                                                    [ngClass]="{ 'is-invalid': isEmailFormSubbmitted && e.Email.errors }"
                                                    placeholder="&nbsp;" (change)="SendOtpToEmail()" />
                                                <label for="Email" class="lable">Enter Email<span class="ColorRed">
                                                        *</span></label>
                                                <div *ngIf="isEmailFormSubbmitted && e.Email.errors" class="invalid-feedback">
                                                    <div *ngIf="e.Email.errors.required">Please enter Email</div>
                                                    <div *ngIf="e.Email.errors.pattern">Enter valid email ID</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col InputBoxOuter">
                                            <div class="has-float-label">
                                                <input type="text" id="EmailOTP" formControlName="EmailOTP"
                                                    (keypress)="isNumber($event)" class="form-control LoginFormInputTextBox"
                                                    maxlength="6" placeholder="&nbsp;"
                                                    [ngClass]="{ 'is-invalid': isEmailFormSubbmitted && e.EmailOTP.errors }" />
                                                <label for="EmailOTP" class="lable">Enter OTP<span class="ColorRed">
                                                        *</span></label>
                                                <div *ngIf="isEmailFormSubbmitted && e.EmailOTP.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="e.EmailOTP.errors.required">please enter otp</div>
                                                    <div *ngIf="e.EmailOTP.errors.pattern">Enter 6 digit OTP number
                                                    </div>
                                                </div>
                                            </div>
                                            <span routerLinkActive="active" class="ForgetPassLink"
                                                (click)="onClickReSendEmailOTP()">
                                                Resend OTP
                                            </span>
                                        </div>
                                    </div>
                                    <div class="text-center SubmitMarginTop mb-4">
                                        <button class="CommonSubmitButton"
                                            [disabled]='e.Email.value == "" || e.EmailOTP.value == ""'
                                            (click)="onEmailLoginClick()">Login</button>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade  " id="three" role="tabpanel" aria-labelledby="three-tab">
                    <div class="row">
                        <div class="col-md-12 mx-auto">
                            <div class="step-opne">
                                <form appNoAutofill autocomplete="off" [formGroup]="MobileLoginForm">
                                    <div class="row">
                                        <div class="col InputBoxOuter">
                                            <div class="has-float-label">
                                                <input type="text" id="Mobile" formControlName="Mobile" autofocus
                                                    class="form-control LoginFormInputTextBox" placeholder="&nbsp;"
                                                    [ngClass]="{ 'is-invalid': isMobileLoginFormSubbmitted && j.Mobile.errors }"
                                                    maxlength="10" (change)="SendOtpToMobile()" (keypress)="isNumber($event)" />
                                                <label for="Mobile" class="lable">Mobile Number<span class="ColorRed">
                                                        *</span></label>
                                                <div *ngIf="isMobileLoginFormSubbmitted && j.Mobile.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="j.Mobile.errors.required">Please enter mobile number
                                                    </div>
                                                    <div *ngIf="j.Mobile.errors.pattern">Enter Valid mobile number.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col InputBoxOuter">
                                            <div class="has-float-label">
                                                <input type="text" id="MobileOTP" formControlName="MobileOTP"
                                                    (keypress)="isNumber($event)" class="form-control LoginFormInputTextBox"
                                                    maxlength="6" placeholder="&nbsp;"
                                                    [ngClass]="{ 'is-invalid': isMobileLoginFormSubbmitted && j.MobileOTP.errors }" />
                                                <label for="MobileOTP" class="lable">Enter OTP<span class="ColorRed">
                                                        *</span></label>
                                                <div *ngIf="isMobileLoginFormSubbmitted && j.MobileOTP.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="j.MobileOTP.errors.required">Please enter OTP</div>
                                                    <div *ngIf="j.MobileOTP.errors.pattern">Enter 6 Digit OTP Number
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <span routerLinkActive="active" class="ForgetPassLink"
                                                    (click)="OnClickReSendButton()">
                                                    Resend OTP
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-center SubmitMarginTop mb-4">
                                        <button class="CommonSubmitButton"
                                            [disabled]='j.Mobile.value == "" || j.MobileOTP.value == ""'
                                            (click)="OnMobileLogin()">Login</button>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- Sign in with Google hidden for now -->
            <button class="btn-google d-none" type="button">
                <!-- Google G SVG -->
                <svg class="g-icon" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
                        fill="#4285F4" />
                    <path
                        d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"
                        fill="#34A853" />
                    <path
                        d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"
                        fill="#FBBC05" />
                    <path
                        d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"
                        fill="#EA4335" />
                </svg>
                Sign in
            </button>
            <!-- <div class="d-flex justify-content-between align-items-center mt-2">
                <span routerLink="/forgot-password-incred" routerLinkActive="active" class="ForgetPassLink " (click)="SendUserType()">
                    Forgot User ID?
                </span>
                <span routerLink="/forgot-password-incred" routerLinkActive="active" class="ForgetPassLink" (click)="SendUserType()">
                    Forgot Password?
                </span>
            </div> -->

            <div class="footer-links" [ngClass]="!IsMobile ? 'mt-5':'mt-3'">
                <a href="/franchise-onboarding" >BP Onboarding</a>
                <span>|</span>
                <a href="/disclaimer">Disclaimer</a>
                 <span>|</span>
                <!-- <a >Privacy Policy</a> 
                <span>|</span> -->
                <a href="/terms-and-conditions">T&Cs</a>
                <span>|</span>
                <a href="/about-us">About Us</a>
            </div>
            <p class="powered">Powered by <span>InCred Markets</span></p>
        </section>
    </div>
    <!-- New Design Ends -->
    <div class="modal" id="AlertModalLogin" appDisabledRightClick>
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content AlertModalContentCls">
                <div class="modal-header AlertModalHeader">Select Client</div>
                <div id="AlertModalContentv" class="modal-body AlertModalBody">

                    <div class="tab-content TabContentData px-0">
                        <div id="Clients" class="tab-pane fade show active">
                            <div class="TableDataMainData MainDataLRPadding pt-15">
                                <div class="table-responsive">
                                    <table id="ClientsTable" class="CommonTable ClientsTable"
                                        *ngIf="isMobileListDisplay">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Mobile Number</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let client of ClientData">
                                                <td>{{client.FirstName}}</td>
                                                <td>{{client.MobileNo}}</td>
                                                <td>
                                                    <button class="BtnCommon"
                                                        style="background-color: var(--primary-color);"
                                                        (click)="OnClickClientSelection(client)">Login</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="modal-footer AlertModalFooter">

                </div>
            </div>
        </div>
    </div>

    <div class="modal" id="AlertModalLoginEmail" appDisabledRightClick>
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content AlertModalContentCls">
                <div class="modal-header AlertModalHeader">Select Client</div>
                <div id="AlertModalContentv5" class="modal-body AlertModalBody">
                    <div class="tab-content TabContentData px-0">
                        <div id="Clients" class="tab-pane fade show active">
                            <div class="TableDataMainData MainDataLRPadding pt-15">
                                <div class="table-responsive">
                                    <table id="ClientsTable" class="CommonTable ClientsTable"
                                        *ngIf="isEmailListDisplay">
                                        <thead>
                                            <tr>
                                                <th>Name.</th>
                                                <!-- <th>PAN Number</th> -->
                                                <th>Email Id</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let client of ClientDataBasedOnEmail">
                                                <td>{{client.FirstName}}</td>
                                                <!-- <td>{{client.PANNo}}</td> -->
                                                <td>{{client.EmailId}}</td>
                                                <td>
                                                    <button class="BtnCommon"
                                                        style="background-color: var(--primary-color);"
                                                        (click)="BasedonEmailSelection(client)">Login</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="modal-footer AlertModalFooter">

                </div>
            </div>
        </div>
    </div>

    <!-- PAN Verification modal (codify-login functional flow — kept as-is) -->
    <div class="modal" id="AlertModalPANVerification" data-backdrop="static" data-keyboard="false"
        appDisabledRightClick>
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content AlertModalContentCls">

                <div class="modal-header AlertModalHeader">PAN Verification <button type="button" class="close"
                        data-dismiss="modal" aria-label="Close" (click)="CloseMainModal()">
                        <span aria-hidden="true">&times;</span>
                    </button></div>
                <p class="OtpVerificationParagraph my-3 mx-4">Please enter the PAN number associated to your account</p>
                <!-- (ngSubmit)="onSubmitVerifyOTP()" -->
                <form class="LoginForm" appNoAutofill autocomplete="off" [formGroup]="CodifyPANForm">
                    <div class="modal-body AlertModalBody">
                        <div class="row justify-content-center">
                            <div class="UserInputContainer">

                                <!-- <div class="has-float-label"> -->
                                    <input formControlName="PAN" id="PANBox" class="form-control LoginFormInputTextBox"
                                    oninput="this.value = this.value.toUpperCase()" maxlength="10"
                                    [ngClass]="{ 'is-invalid': PANFormSubmitted && codifyPANForm.PAN.errors }"
                                    />
                                        <!-- <label for="PAN">
                                            Enter PAN
                                        </label> -->
                                    <div *ngIf="PANFormSubmitted && codifyPANForm.PAN.errors" class="text-danger">
                                        <div *ngIf="codifyPANForm.PAN.errors.required">Please enter PAN</div>
                                        <div *ngIf="codifyPANForm.PAN.errors.pattern"> Please enter valid PAN</div>
                                    </div>
                                <!-- </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer AlertModalFooter">
                        <button class="CommonSubmitButton"
                            (click)='onSubmitVerifyPAN()'>Verify</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>

<ng-template #other_content></ng-template>
